import styled from "styled-components";

import awardBg from '@/images/everyday-award-bg.png'
import awardBgHover from '@/images/everyday-award-bg-hover.png'
// import awardBg1 from '@/images/everyday-award-bg-01.png'
// import awardBg1Hover from '@/images/everyday-award-bg-01-hover.png'
// import awardBg2 from '@/images/everyday-award-bg-02.png'
// import awardBg2Hover from '@/images/everyday-award-bg-02-hover.png'
// import awardBg3 from '@/images/everyday-award-bg-03.png'
// import awardBg3Hover from '@/images/everyday-award-bg-03-hover.png'

import tip from '@/images/everyday-tip.png'

const View = styled.div`
  position: absolute;
  left: -20px;
  top: 33px;
  width: 470px;
  height: 470px;
  text-align: center;

  span.changeGame {
    display: inline-block;
    position: absolute;
    right: 80px;
    top: 25px;
    font-size: 16px;
    text-decoration: underline;
    color: #852b03;
    cursor: pointer;
  }

  p.probabilityTip {
    position: absolute;
    left: 50%;
    bottom: 32px;
    width: 290px;
    transform: translateX(-50%);
    font-size: 14px;
    text-shadow: 0 0 #852b03;
    color: #009cfa;
  }

  p.taskName {
    position: absolute;
    left: 50%;
    top: 66px;
    transform: translateX(-50%);
    font-size: 20px;
    font-weight: bold;
    color: #e72d4b;
    // text-shadow: 1px 1px 4px #852b03, -1px -1px 4px #852b03;
  }

  p.tipTxt {
    position: absolute;
    left: 50%;
    top: 100px;
    transform: translateX(-50%);
    font-size: 14px;
    font-weight: bold;
    color: #ffffff;

    span {
      display: inline-block;
      vertical-align: middle;
      height: 16px;
      width: 16px;
      border-radius: 50%;
      border: 1px solid #ffffff;
      text-align: center;
      font-size: 12px;
      font-weight: bold;
      margin-left: 6px;
      cursor: pointer;
    }
  }

  ul {
    margin-top: 125px;
    width: 100%;
    height: 210px;
    text-align: center;

    li {
      display: inline-block;
      margin: 0 18px;
      width: 138px;
      height: 208px;
      position: relative;
      cursor: pointer;
      transition: all 0.15s;
      background-position: center center;
      background-repeat: no-repeat;


      &:nth-child(1) {
        background-image: url("${awardBg}");
        &:hover,
        &.active {
          background-image: url("${awardBgHover}");
        }
      }

      &:nth-child(2) {
        margin-left: -12px;
        background-image: url("${awardBg}");
        &:hover,
        &.active {
          background-image: url("${awardBgHover}");
        }
      }

      &:nth-child(3) {
        margin-left: -12px;
        background-image: url("${awardBg}");
        &:hover,
        &.active {
          background-image: url("${awardBgHover}");
        }
      }

      img {
        width: 80px;
        height: 80px;
        position: absolute;
        left: 49%;
        top: 63px;
        transform: translateX(-50%);
      }

      p {
        font-size: 16px;
        font-weight: bold;
        position: absolute;
        bottom: 30px;
        // left: 5px;
        width: 100%;
        background: linear-gradient(to bottom, #fffffb, #fffcce, #fff88e);
        -webkit-background-clip: text;
        background-clip: text;
        -webkit-text-fill-color: transparent;
        color: transparent;
        // color: #fffdcf;
        // text-shadow: 1px 1px 2px #f0461f, -1px -1px 2px #f0461f;
      }
    }
  }

  .button {
    margin-top: 0;
  }
`;

const ToolRule = styled.div`
  width: 289px;
  height: 210px;
  background-image: url(${tip});
  position: absolute;
  left: -80px;
  top: -95px;

  .probabilityBox {
    position: absolute;
    width: 289px;
    height: 210px;
    right: 44px;
    top: 70px;
  }

  .probability {
    color: #fff;
    text-shadow: 0 0 5px #e92410;
    font-weight: bold;
    text-align: right;
    line-height: 38px;
    font-size: 14px;
  }
`

export {
  View,
  ToolRule
}
